"use strict";

exports.topInt = 2147483647;
exports.bottomInt = -2147483648;

exports.topChar = String.fromCharCode(65535);
exports.bottomChar = String.fromCharCode(0);



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Bounded.js
// module id = 80
// module chunks = 0